import React from 'react';
import { Icon } from '../Icon/Icon';
import topbarStyles from './Topbar.module.css';
import emailIcon from '../../assets/img/icons/email.svg';
import locationPinIcon from '../../assets/img/icons/location-pin.svg';
import phoneIcon from '../../assets/img/icons/phone.svg';
import { LanguageDropdown } from '../LanguageDropdown/LanguageDropdown';

export function Topbar() {
  return (
    <div className={topbarStyles.topbar}>
      <Icon.InlineGroup>
        <a href='https://wa.me/5491131311122' target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'none' }}>
          <Icon img={phoneIcon} label='+54 9 11 3131 1122' classes={topbarStyles.item} />
        </a>
        <a href='mailto:info@lalliance.com.ar' target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'none' }}>
          <Icon img={emailIcon} label='info@lalliance.com.ar' classes={topbarStyles.item} />
        </a>
        <Icon img={locationPinIcon} label='Av. Mitre 2900, Sarandí, Buenos Aires, AR' classes={topbarStyles.item} />
      </Icon.InlineGroup>
      <LanguageDropdown />
    </div>
  );
}
